export default __webpack_public_path__ + "static/media/wallet.0f0ba0f4.png";